import Extension from "../base/extension";
import Stencil from "../stencil";

class Cart extends Extension {
  minicart;
  selectors = { 
    variant_quick_add: "[data-quick-add]"
  }

  constructor(name) {
    super(name);
  }

  init() {
    this.minicart = new bootstrap.Offcanvas(document.querySelector("#cart-offcanvas"));

    // TODO: Custom element
    // document.body.addEventListener('click', e => {
    //   if(e.target.closest(this.selectors.variant_quick_add)){
    //     this.onVariantQuickAdd(e);
    //   };
    // });
  }

  /**
   * Add a variant using the data-quick-add attribute as the variant ID
   * 
   * @param {Event} e 
   */
  // onVariantQuickAdd(e) {
  //   let quickAddElement = e.target.closest(this.selectors.variant_quick_add);
  //   let spinner = quickAddElement.querySelector(".spinner-overlay");
  //   let item = { id: quickAddElement.dataset.quickAdd, quantity: 1 };
  //   if(spinner) {
  //     quickAddElement.querySelectorAll("span").forEach(e => {
  //       e.classList.add("opacity-0")
  //     });
  //     spinner.classList.remove("d-none");
  //   }

  //   let variantId = quickAddElement.dataset.quickAdd;
  //   let properties = {};
  //   if(quickAddElement.dataset.quickAddProperties){
  //     let propertiesArray = JSON.parse(atob(quickAddElement.dataset.quickAddProperties));
  //     propertiesArray.forEach(e => {
  //       let propertyParts = e.split("||||");
  //       properties[propertyParts[0]] = propertyParts[1];
  //     });
  //   } 
  //   item.properties = properties;

  //   let sellingPlanId = quickAddElement.dataset?.quickAddSellingPlan || null;
  //   if(sellingPlanId){
  //     item.selling_plan = sellingPlanId;
  //   }

  //   this.add(item).finally(() => {
  //     if(spinner) {
  //       quickAddElement.querySelectorAll("span").forEach(e => {
  //         e.classList.remove("opacity-0");
  //       });
  //       spinner.classList.add("d-none");
  //     }
  //   });
  // }

  async render() {
    let shouldOpenMinicart = true;
    if(window.disableNextMinicartOpen){
      shouldOpenMinicart = false;
      delete window.disableNextMinicartOpen;
    }

    // Actually get the cart 
    if(Stencil.isCartPage()){
      this.renderCart();
      this.renderMinicart(false);
    } else {
      this.renderMinicart(shouldOpenMinicart);
    }

    let response = await fetch(`${routes.cart_url}.js`);
    response = await response.json();
    let event = new CustomEvent("cart:refreshed", {
      detail: { response }
    });
    document.dispatchEvent(event);
  }

  async renderMinicart(open = true) {
    // Get the template-namespaced ID of the cart-offcanvas-content section to dynamically render
    const sectionId = document.querySelector(".section-offcanvas-cart").id.replace("shopify-section-", "");

    try {
      const promise = await fetch(`${location.pathname}?section_id=${sectionId}`);
      const sectionHtml = await promise.text();
      const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const refreshedElement = parsedHtml.querySelector("#cart-offcanvas-content");

      // See https://developer.chrome.com/docs/web-platform/view-transitions/same-document
      let applyViewTransitionChanges = () => {
        document.querySelector("#cart-offcanvas-content").outerHTML = refreshedElement.outerHTML;
      }

      // Fallback for browsers that don't support this API:
      if (!document.startViewTransition) {
        applyViewTransitionChanges();
      }
      document.startViewTransition(() => applyViewTransitionChanges());

      const numItems = parseInt(parsedHtml.querySelector("#cart-offcanvas-content").dataset.cartItemsCount);

      let itemCounts = document.querySelectorAll("[data-cart-item-count]");
      itemCounts.forEach(e => {
        e.dataset.cartItemCount = numItems;
        e.innerHTML = numItems; 
      });

      let cartJSON = JSON.parse(parsedHtml.querySelector("#minicart-json").innerText)
      var event = new CustomEvent("minicart:rendered", { detail: { cart: cartJSON }});
      document.dispatchEvent(event);

      if(open){
        this.minicart.show();
      }
    } finally {
      document.querySelectorAll('.cart-loading').forEach(e => e.classList.add('d-none'));
    }
  }

  async renderCart() {
    // Get the template-namespaced ID of the cart-items section to dynamically render
    const sectionId = document.querySelector(".section-cart-items").id.replace("shopify-section-", "");

    try {
      const promise = await fetch(`${location.pathname}?section_id=${sectionId}`);
      const sectionHtml = await promise.text();
      const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');

      // Update any cart count displays (e.g. badge next to icon) with the new amount
      const numItems = parseInt(parsedHtml.querySelector("#cart-container").dataset.cartItemsCount);
      let itemCounts = document.querySelectorAll("[data-cart-item-count]");
      itemCounts.forEach(e => {
        e.dataset.cartItemCount = numItems;
        e.innerHTML = numItems;
      });

      if(numItems > 0){
        // Update any live attributes with their new refreshed values
        document.querySelectorAll("[data-live-attribute^='cart']").forEach(element => {
          let attributeName = element.dataset.liveAttribute;
          let refreshedElement = parsedHtml.querySelector(`[data-live-attribute="${attributeName}"]`);
          if(refreshedElement){
            let refreshedAttributeValue = refreshedElement.dataset[attributeName];
            element.dataset[attributeName] = refreshedAttributeValue;
          }
        });

        // Update any live regions with their new refreshed content
        document.querySelectorAll("[data-live-region='cart']").forEach(element => {
          let refreshedElement = parsedHtml.getElementById(element.id)
          if(refreshedElement){
            element.innerHTML = refreshedElement.innerHTML;
          }
        });

        window.Klarna?.OnsiteMessaging.refresh();
      } else {
        // Update the entire section, as cart is now empty
        document.querySelector("#cart-container").outerHTML = parsedHtml.querySelector("#cart-container").outerHTML;
      }

      // Send an event with the contents of the new cart
      let cartJSON = JSON.parse(parsedHtml.querySelector("#cart-json").innerText)
      var event = new CustomEvent("cart:rendered", { detail: { cart: cartJSON }});
      document.dispatchEvent(event);
    } finally {
      document.querySelectorAll('.cart-loading').forEach(e => e.classList.add('d-none'));
    }
  }

  add(data) {
    // Show loading indicators
    document.querySelectorAll('.cart-loading').forEach(e => e.classList.remove('d-none'));

    // Prepare fetch config
    const config = { ...Stencil.fetchConfig('javascript') };

    // Determine payload type
    if (data instanceof FormData) {
      config.body = data;
      delete config.headers['Content-Type']; 
    } else {
      config.body = JSON.stringify({ items: Array.isArray(data) ? data : [data] });
    }

    // Fetch and process response
    return fetch(routes.cart_add_url, config)
      .then(response => response.json())
      .then(response => response.status 
          ? this.handleError(response) 
          : this.handleAdd(response, window.cartStrings.added)
      );
  }

  change(data) {
    // Show loading indicators
    document.querySelectorAll('.cart-loading').forEach(e => e.classList.remove('d-none'));

    // Prepare fetch config
    const config = { ...Stencil.fetchConfig('javascript'), body: JSON.stringify(data) };

    // Fetch and process response
    return fetch(routes.cart_change_url, config)
      .then(response => response.json())
      .then(response => response.status 
          ? this.handleError(response) 
          : this.handleChange(response, window.cartStrings.updated)
      );
  }

  clear() {
    // Show loading indicators
    document.querySelectorAll('.cart-loading').forEach(e => e.classList.remove('d-none'));

    // Prepare fetch config
    const config = Stencil.fetchConfig('javascript');

    // Fetch and process response
    return fetch(routes.cart_clear_url, config)
      .then(response => response.json())
      .then(response => response.status 
        ? this.handleError(response) 
        : (window.disableNextMinicartOpen = true, this.handleClear(response, window.cartStrings.updated))
      );
  }

  setCartAttributes(data) {
    // Setup the fetch request
    const config = Stencil.Utilities.fetchConfig('javascript');

    // Determine the payload
    config.body = JSON.stringify({ attributes: data });

    // Parse the response to JSON for any other callbacks
    const fetchPromise = fetch(`${routes.cart_update_url}`, config).then(response => response.json());

    // Handle the promise
    fetchPromise.then(response => {
      if(response.status) {
        this.handleError(response);
      } else {
        window.disableNextMinicartOpen = true;
        this.handleAttributeChange(response, window.cartStrings.updated);
      }
    });

    // Pass the promise back to the caller to do any caller-specific handling
    return fetchPromise;
  }

  async setDiscounts(codes) {
    document.querySelectorAll('.cart-loading').forEach(e => e.classList.remove('d-none'));

    const config = { ...Stencil.fetchConfig('javascript'), body: JSON.stringify({ discount: codes.join(',') }) };

    const response = await fetch(routes.cart_update_url, config);
    const result = await response.json();

    if(result.status){
      this.handleError(result);
      return result;
    }

    window.disableNextMinicartOpen = true;
    this.render();
    return result;
  }

  async clearCartAttributes(attributes = []) {
    if(attributes.length == 0){
      // Only way to know what attributes to clear is to check what's been set
      const cart = await fetch(`${routes.cart_url}.json`).then(response => response.json());
      attributes = Object.keys(cart.attributes);
    }

    const emptyAttributes = attributes.reduce((acc, curr) => {
      acc[curr] = '';
      return acc;
    }, {});

    return this.setCartAttributes(emptyAttributes);
  }

  handleAdd(addResponse, message) {
    // addResponse is just the 'items' object 
    console.log(this.logPrefix, addResponse, message);
    let event = new CustomEvent("cart:added", { detail: {
      addResponse
    }});
    document.dispatchEvent(event);
    this.render();
  }

  handleChange(changeResponse, message) {
    // changeResponse is the full cart
    console.log(this.logPrefix, changeResponse, message);
    let event = new CustomEvent("cart:changed", { detail: {
      changeResponse
    }});
    document.dispatchEvent(event);
    this.render();
  }

  handleClear(clearResponse, message) {
    console.log(this.logPrefix, clearResponse, message);
    let event = new CustomEvent("cart:cleared", { detail: {
      clearResponse
    }});
    document.dispatchEvent(event);
    this.render();
  }

  handleAttributeChange(updateResponse, message) {
    console.log(this.logPrefix, updateResponse, message);
    let event = new CustomEvent("cart:updated", { detail: {
      updateResponse
    }});
    document.dispatchEvent(event);
    this.render();
  }

  handleError(response) {
    console.log(this.logPrefix, 'error', response);
    let message = "";
    if (typeof response.description === 'object'){
      for (const [key, value] of Object.entries(response.description)) {
        message = `${message} ${key} ${value}`;
      }
    } else {
      message = response.description;
    }
    Stencil.toast("warning", message, "fal fa-exclamation-triangle");
    window.disableNextMinicartOpen = true;
    return this.render();
  }
}

export default Cart;